// sms.service.ts
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SmsService {

  constructor(private http: HttpClient) { }

  sendCode(phone: string) {
    return this.http.post('/send-code', { phone });
  }

  verifyCode(code: string) {
    return this.http.post('/verify-code', { code });
  }
}